import clsx from 'clsx';
import { Link } from 'react-router-dom';

import EmptyIcon from '@/assets/icons/empty.svg';
import { Typography } from '@/components/ui/typography';

import { Button } from './button';

interface EmptyStateProps {
  className?: string;
  icon?: string;
  header: string;
  description: string;
  buttonIcon?: string;
  buttonTitle?: string;
  onClick?: () => void;
  isDisabled?: boolean;
  link?: string;
}

export function EmptyState({
  className,
  icon,
  header,
  description,
  buttonIcon,
  buttonTitle,
  onClick,
  isDisabled,
  link,
}: EmptyStateProps) {
  const showButton = (onClick || link || isDisabled) && buttonTitle;

  const buttonContent = (
    <>
      {buttonIcon && <img src={buttonIcon} alt="Error" />}
      {buttonTitle}
    </>
  );

  return (
    <div
      className={clsx(
        'mx-auto flex w-[300px] flex-1 flex-col items-center justify-center gap-2',
        className,
      )}
    >
      <img src={icon ?? EmptyIcon} alt="Empty" />
      <Typography variant="body2">{header}</Typography>
      <Typography variant="subtitle1" className="text-center">
        {description}
      </Typography>

      {showButton && (
        <Button onClick={onClick} className="mt-2" disabled={isDisabled}>
          {link ? <Link to={link}>{buttonContent}</Link> : buttonContent}
        </Button>
      )}
    </div>
  );
}
